import { ContinuousInterviewingModalSource } from '__generated__/graphql';

// Which panel the modal body shows. `Confirmation` is the post-answer thank-you.
// (The error and loading views are derived from the Apollo mutation, not stored.)
export enum InterviewInviteStep {
  Prompt = 'prompt',
  Schedule = 'schedule',
  Confirmation = 'confirmation',
  CapReached = 'capReached',
}

interface ShowInterviewInvitePayload {
  source: ContinuousInterviewingModalSource;
}

export const interviewInviteActions = {
  SHOW_INTERVIEW_INVITE_MODAL: 'SHOW_INTERVIEW_INVITE_MODAL',
  HIDE_INTERVIEW_INVITE_MODAL: 'HIDE_INTERVIEW_INVITE_MODAL',
  SET_INTERVIEW_INVITE_STEP: 'SET_INTERVIEW_INVITE_STEP',
  SET_INTERVIEW_INVITE_CALENDLY_OPEN: 'SET_INTERVIEW_INVITE_CALENDLY_OPEN',

  showInterviewInviteModal: (payload: ShowInterviewInvitePayload) => ({
    type: interviewInviteActions.SHOW_INTERVIEW_INVITE_MODAL,
    payload,
  }),

  hideInterviewInviteModal: () => ({
    type: interviewInviteActions.HIDE_INTERVIEW_INVITE_MODAL,
    payload: undefined,
  }),

  setInterviewInviteStep: (step: InterviewInviteStep) => ({
    type: interviewInviteActions.SET_INTERVIEW_INVITE_STEP,
    payload: step,
  }),

  setInterviewInviteCalendlyOpen: (open: boolean) => ({
    type: interviewInviteActions.SET_INTERVIEW_INVITE_CALENDLY_OPEN,
    payload: open,
  }),
};
